import type { User } from "@supabase/supabase-js";
import { USE_MOCK_AUTH } from "@/config";
import { getDevUserId } from "@/lib/dev-user";

/**
 * Creates a mock user with the current dev user ID
 * This function ensures we always get the latest dev user ID,
 * even if the env var changes (though Next.js restart is still recommended)
 */
export function createMockUser(): User {
  const mockUserId = getDevUserId();
  if (typeof window === 'undefined' && process.env.NODE_ENV === 'development') {
    console.log('[mock-user] Creating MOCK_USER with id:', mockUserId);
  }
  return {
    id: mockUserId,
    email: "dev@example.com",
    app_metadata: { provider: "email" },
    user_metadata: {
      full_name: "Development User",
      avatar_url: "https://via.placeholder.com/150"
    },
    aud: "authenticated",
    role: "authenticated",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  };
}

// Simplified mock user with only essential fields
// Uses DEV_USER_ID from .env if set, otherwise falls back to DEV_USER_ID constant
// Note: This is evaluated at module load time, so restart Next.js after changing DEV_USER_ID
export const MOCK_USER: User = createMockUser();

// Development mode flag
export const isDevMode = USE_MOCK_AUTH; 